import api from '/src/api.js';

export function getDeviceTypes (deviceId, options = {}) {
	return api.get(`/check-type-device/device/${deviceId}`, {
		...options,
		// query: {
		//     limit: 100,
		// },
	});
}
